import React from 'react';

const InfoList = ({ title, items }) => {
  return (
    <div className="info-list">
      <p className="info-list-title">{title}</p>
      <ul>
        {items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default InfoList;
